import { render, staticRenderFns } from "./DealPackView.vue?vue&type=template&id=227483ac&scoped=true&"
import script from "./DealPackView.vue?vue&type=script&lang=js&"
export * from "./DealPackView.vue?vue&type=script&lang=js&"
import style0 from "./DealPackView.vue?vue&type=style&index=0&id=227483ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227483ac",
  null
  
)

export default component.exports